export default "__VITE_ASSET__CXZxFAp3__"